<template>
<div class="modal_wrapper">
  <div class='container'>
    <div class='modal_container'>
      <div class="modal_header">
        <img :src='caution' height=25px>
        {{confirm}}
      </div>
      <div class="modal_body">
        <div class="body">
          {{question}}
        </div>
        <div class="modal_buttons">
          <input type=button :value='cancelButton' class="cancel_button" @click="$emit('close')">
          <input type=button :value='exportButton' class="finish_button" @click="$emit('export')">
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: ['exportList'],
  data () {
    return {
      caution: require('../../../../img/caution.png'),
      confirm: '確認',
      question: 'エクスポートを行いますか？',
      cancelButton: 'キャンセル',
      exportButton: 'エクスポート'
    }
  }
}
</script>
<style scoped>
.modal_wrapper {
  background-color: rgba(0, 0, 0, .5);
}
.container {
  display: table-cell;
  vertical-align: middle;
}
.body {
  width: 100%;
  height: 117px;
  padding-top: 40px;
  text-align: center;
}
.modal_header {
  background-color: #33CCFF;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/modalWindow/exportModalWindow.vue